import FacebookCircularProgress from "../Loaders/FacebookCircularProgress";
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: theme.palette.background.default,
  },
}));

const SplashScreen = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <FacebookCircularProgress size={80} />
    </div>
  );
};

export default SplashScreen;
